<template>
  <section class="vbox">
    <section class="scrollable padder">
      <Breadcrumb :items="breadcrumbList"/>
      <ListFilter title="Vendor Type" @show-form="showForm"/>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Vendor Type
          </h4>
        </template>
        <template #body>
          <AddVendorType
            :typeId="typeId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  VENDOR TYPES
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Vendor Type</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in typeList"
                        :key="item.type_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ item.type_name }}</td>
                        <td>
                          <a
                            v-on:click="showForm(item.type_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddVendorType from "../components/AddVendorType.vue";
import PanelModal from "../components/PanelModal.vue";
import Breadcrumb from "../components/Breadcrumb.vue";
import ListFilter from "../components/ListFilter.vue";

export default {
  name: "VendorType",

  components: {
    Breadcrumb,
    AddVendorType,
    PanelModal,
    ListFilter
},
  data() {
    return {
      breadcrumbList: [{title: 'Home', link: '#', icon: 'fa fa-dashboard', active: false },{title: 'Vendor Types', link: false, icon: false, active: true }],
      showFormModal: false,
      baseUrl: this.$store.state.baseURL,
      typeList: {},
      typeId: "",
      StatusActive: true,
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_vendor_types", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.typeList = response.data.values;
          } else {
            this.typeList = data.typeList;
          }
        });
    },
    showForm: function(id = '') {
      this.typeId = id;
      this.showFormModal = true;
    },
  },
  mounted(){
    this.getList()
  }
};
</script>
